export default __webpack_public_path__ + "static/media/student1.046d9e13.png";